"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataState = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const RetentionPageHighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/state/data/RetentionPageHighchartsOptionsProvider");
const antd_1 = require("antd");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const RetentionChartSettingsComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/state/data/highchartsSettings/RetentionChartSettingsComponent");
const react_router_dom_1 = require("react-router-dom");
const RetentionPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionPageDataProvider");
const RetentionPageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionPageModelProvider");
const RetentionFormComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/state/data/RetentionFormComponent");
const RetentionHighchartsComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/state/data/RetentionHighchartsComponent");
const RetentionExportHighchartsButton_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/state/data/RetentionExportHighchartsButton");
const RetentionPopover_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/help/RetentionPopover");
const Analytics_1 = require("src/hello_assets/src/util/analytics/Analytics");
const DataState = () => {
    (0, react_1.useEffect)(() => {
        Analytics_1.Analytics.trackViewRetention();
    }, []);
    return React.createElement(React.Fragment, null,
        React.createElement(RetentionPageHighchartsOptionsProvider_1.RetentionPageHighchartsOptionsProvider, null,
            React.createElement(antd_1.PageHeader, { title: React.createElement(antd_1.Space, null,
                    React.createElement(React.Fragment, null, "Retention"),
                    React.createElement(RetentionPopover_1.RetentionPopover, null)), extra: React.createElement(antd_1.Space, null,
                    React.createElement(RetentionExportHighchartsButton_1.RetentionExportHighchartsButton, null)) }),
            React.createElement(PageContent_1.default, null,
                React.createElement(PageContent_1.default.Card, null,
                    React.createElement(RetentionChartSettingsComponent_1.RetentionChartSettingsComponent, null),
                    React.createElement(RetentionHighchartsComponent_1.RetentionHighchartsComponent, null)),
                React.createElement(PageContent_1.default.CardSpacer, null),
                React.createElement(PageContent_1.default.Card, null,
                    React.createElement(antd_1.Row, null,
                        React.createElement(antd_1.Col, { span: 24 },
                            React.createElement(RetentionFormComponent_1.RetentionFormComponent, null)))))),
        process.env.NODE_ENV === "development" ? React.createElement(DebugView, null) : null);
};
exports.DataState = DataState;
const DebugView = () => {
    const retentionPageDataContext = (0, RetentionPageDataProvider_1.useRetentionPageDataContext)();
    const retentionPageModelContext = (0, RetentionPageModelProvider_1.useRetentionPageModelContext)();
    const location = (0, react_router_dom_1.useLocation)();
    return React.createElement(React.Fragment, null,
        React.createElement(PageContent_1.default, null,
            React.createElement(PageContent_1.default.CardSpacer, null),
            React.createElement(PageContent_1.default.Card, null,
                React.createElement(antd_1.Row, { gutter: [16, 16] },
                    React.createElement(antd_1.Col, { span: 24 },
                        "location:",
                        React.createElement("br", null),
                        React.createElement("span", { style: { fontSize: "10px", maxHeight: 180, wordBreak: "break-all" } }, decodeURI(location.search))),
                    React.createElement(antd_1.Col, { span: 8 },
                        "pageModelFormState:",
                        React.createElement("br", null),
                        React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(retentionPageModelContext.pageModelFormState, null, 4))),
                    React.createElement(antd_1.Col, { span: 8 },
                        "dataURLState:",
                        React.createElement("br", null),
                        React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(retentionPageDataContext.urlState, null, 4))),
                    React.createElement(antd_1.Col, { span: 8 },
                        "dataState:",
                        React.createElement("br", null),
                        React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(retentionPageDataContext.state, null, 4)))))));
};
